<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
    <dx-date-box formField required formControlName="date" dateSerializationFormat="yyyy-MM-dd"
        [label]="'common.date' | translate | ucfirst"></dx-date-box>
    <dx-number-box formControlName="cost" formField required
        [label]="'entity.standardCost' | translate | ucfirst">
    </dx-number-box>
</form>